<div class="xScroll mt-2">

  <table mat-table [dataSource]="tableRows" matSort [matSortActive]="defaultSort" matSortDirection="desc" class="table table-striped table-hover headerTextNowrap">
    <ng-container *ngFor="let column of columnDefs">
      <ng-container [matColumnDef]="column.field">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{column.label}}</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="column.type == 'date' && !dateFormat">
            {{row[column.field] | slice: 0: 10}}
          </ng-container>
          <ng-container *ngIf="column.type == 'date' && dateFormat">
            {{row[column.field] | date: dateFormat }}
          </ng-container>
          <ng-container *ngIf="column.type != 'date' && column.type != 'button'">
            {{row[column.field]}}
          </ng-container>
          <ng-container *ngIf="column.type == 'button'">
            <button class="action-btn" mat-flat-button color="primary" (click)="deleteRow(row)">Delete</button>
          </ng-container>
        </td>
      </ng-container>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: stickyHeader"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns" (click)="rowClicked(row)" (dblclick)="rowDblClicked(row)"></tr>

  </table>
  <div class="loadingShade" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>
</div>
<mat-paginator *ngIf="showPagination" [pageSizeOptions]="[10,25,100]"></mat-paginator>
